import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cf7777f&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf7777f')) {
      api.createRecord('1cf7777f', component.options)
    } else {
      api.reload('1cf7777f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cf7777f&lang=pug", function () {
      api.rerender('1cf7777f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nav/headerNav/centerHeaderNav/index.vue"
export default component.exports